export default __webpack_public_path__ + "static/7-5f8513909cada82cec577dd582c4ef5b.webp";